module.exports = __webpack_public_path__ + "img/23F8.c1621a89.svg";